export const locationToPrettyFormat = ({
  buildNum,
  audNum,
}: {
  buildNum: string;
  audNum: string;
}): string => {
  const cscKaiOlimp = 'КСК КАИ ОЛИМП';
  if (
    buildNum.toUpperCase() === cscKaiOlimp &&
    audNum.toUpperCase() === cscKaiOlimp
  ) {
    return 'КСК КАИ ОЛИМП';
  }
  const isBuildNumNumber = !isNaN(Number(buildNum));
  const isAudNumNumber = !isNaN(Number(audNum));
  return `${buildNum} ${isBuildNumNumber ? 'здание ' : ' '}— ${audNum}${isAudNumNumber ? ' аудитория' : ''}`;
};
